module.exports = __webpack_public_path__ + "static/img/bg-banner-case-detail-facilities.536f6526.png";